import { Common } from '@stockbit/ui';
import dynamic from 'next/dynamic';
import { useMemo, useState } from 'react';
import { showFileName } from 'global/StreamWidget/utils';
import { IconCloseFile } from 'global/StreamCompose/FileContainer/styled';
import { AttachmentDocumentContainer, DocumentItem, ExtensionBadge } from './styled';
import { ModalDocument } from './ModalDocumentPreview';
import { FileType } from '../types';

const PDFPreview = dynamic(() => import('global/PDFPreview'), { ssr: false });

const { Flex, Text } = Common;

interface DocumentsProps {
  documents: FileType[];
  onSetDocuments: (documents: FileType[]) => void;
}

const Documents = ({
  documents,
  onSetDocuments,
}: DocumentsProps) => {
  const [showModal, setShowModal] = useState(false);
  const [selectedDocument, setSelectedDocument] = useState(null);

  const handleRemoveFile = (file) => {
    const docIndex = documents.findIndex((doc) => doc.preview === file.preview);
    const documentFiles = [...documents];
    documentFiles.splice(docIndex, 1);
    // remove file here
    onSetDocuments(documentFiles);
  };

  const documentList = useMemo(() => documents.map((doc) => {
    const humanFilename = doc.isNew === true ? doc.file.name : showFileName(doc?.fileUrl);
    const parsedFileName = humanFilename.length > 33 ? `${humanFilename.substr(0, 20)}...${humanFilename.substr(humanFilename.length - 6, 6)}` : humanFilename;

    return {
      preview: doc.preview,
      extension: 'PDF',
      filename: parsedFileName,
    };
  }), [documents]);

  const onClickDocument = (doc) => {
    setSelectedDocument(doc.preview);
    setShowModal(true);
  };

  return (
    <AttachmentDocumentContainer>
      {documentList.map((doc) => (
        <DocumentItem onClick={() => onClickDocument(doc)}>
          <Flex>
            <ExtensionBadge>
              <Text color="#FFFFFF" family="bold" weight="700" size="9px" height="16px" pt="1px">
                {doc.extension}
              </Text>
            </ExtensionBadge>
            <Text as="a" color="#333333" ellipsis>
              {doc.filename}
            </Text>
          </Flex>
          <IconCloseFile
            className="icon-compose_close"
            onClick={() => handleRemoveFile(doc)}
          />
        </DocumentItem>
      ))}
      <ModalDocument
        centered
        closable
        footer={null}
        visible={showModal}
        onCancel={() => setShowModal(false)}
        style={{
          width: 500,
          position: 'unset',
        }}
        destroyOnClose
        transitionName=""
        maskTransitionName=""
        maskStyle={{
          backgroundColor: 'rgba(18,18,18,0.7)',
        }}
        maskClosable
        width={1000}
      >
        <PDFPreview
          src={selectedDocument}
          shared
          maxHeight="calc(100vh - 112px)"
          initialVisibility
        />
      </ModalDocument>
    </AttachmentDocumentContainer>
  );
};

export default Documents;
